import { render, staticRenderFns } from "./Generador.vue?vue&type=template&id=1d236088&scoped=true&"
import script from "./Generador.vue?vue&type=script&lang=js&"
export * from "./Generador.vue?vue&type=script&lang=js&"
import style0 from "./Generador.vue?vue&type=style&index=0&id=1d236088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d236088",
  null
  
)

export default component.exports